<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
                        <div class="modal-container" @click.stop>

                            <div class="modal-header row" style="justify-content: flex-end;">
                                <div class="col">
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>

                            <div class="modal-body">

                                <div v-if="center == null && markers == null" class="text-center" style="padding: 300px 0">
                                    <span class="loading">Loading...</span>
                                </div>

                                <div v-else>
                                    <GmapMap
                                        :center="center"
                                        :zoom="zoom"
                                        map-type-id="terrain"
                                        style="width: 100%; min-height: 50vh"
                                        :options="gMapOptions"
                                    >
                                        <GmapCluster>
                                            <gmap-marker v-for="(m, index) in markers"
                                                :position="m.lat ? m: {lat: 0.00000 , lng: 0.0000}"
                                                :clickable="true"
                                                :key="index"
                                                @click="errorPrint"
                                            ></gmap-marker>
                                        </GmapCluster>
                                    </GmapMap>

                                    <div>
                                        <vue-universal-table
                                            :data="tableData"
                                            tbody_height="200px"
                                        ></vue-universal-table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
            </div>
        </div>
    </transition>
</template>

<script>
    import qs from 'qs';

    export default {
        data() {
            return {
                gMapOptions : {
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    disableDefaultUi: false
                },

                unalteredData : null,
                center : null,
                markers : null,
                zoom : 7,
            }
        },
        props : ['filter'],
        mounted() {
            // this.markers = [{
            //     lat : this.coordinate.lat,
            //     lng : this.coordinate.lng
            // }]
            this.fetchData();
        },
        methods: {
            fetchData () {
                let url = `/suspect-report/detail?qrcode=${this.filter.qrcode}&start=${this.filter.start}&end=${this.filter.end}&reason=${this.filter.reason}`
                if (this.filter.distance != null){
                    url = url + `&distance=${this.filter.distance}`
                }

                this.$http.get(url)
                .then((resp)=>{
                    //Search Center
                    let lat = 0;
                    let lng = 0;

                    this.tableData = resp.data.data.map(x=>{return{
                        "QR Code" : x.qrcode,
                        "Part Number" : x.part_number,
                        "Scan Date" : x.scan_date,
                        "Latitude" : x.lat ? x.lat : 'N/A',
                        "Longitude" : x.lng ? x.lng : 'N/A',
                        "Customer Type" : x.customer_type,
                    }});
                    let data = resp.data.data.filter(x=>{return x.lat && x.lng});
                    let length = data.length;

                    data.map(x=>{
                        lat += x.lat;
                        lng += x.lng;
                    });

                    this.center = length > 0 ? {
                        lat:lat/data.length,
                        lng:lng/data.length
                    } : {lat:-2.548926, lng:118.0148634};
                    if (length == 0) this.zoom = 5;
                    this.markers = data;
                })
                .catch((err)=>{console.log(err)});
            },
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        /* padding: 20px 30px; */
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        padding: 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }

    .loading{
        color: #616161;
        font-size: 90px;
        text-shadow: 4px 4px 6px #BDBDBD;
    }
</style>